import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import InputField from '#component/form/input';

export const StyledAccordion = styled(Accordion, {
  shouldForwardProp: prop => prop !== 'hasError'
})(({ theme, hasError }) => ({
  ...(hasError && {
    border: `2px solid ${theme.palette.error.main}`
  })
}));

export const StyledAccordionSummary = styled(AccordionSummary)({
  '& > div': {
    alignItems: 'center',
    justifyContent: 'space-between'
  }
});

export const TitleCnt = styled('div')({
  display: 'flex'
});

export const StyledTitle = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1)
}));

export const StyledAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  width: 24,
  height: 24,
  fontSize: 'small'
}));

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  display: 'grid',
  gridGap: theme.spacing(2),
  gridTemplateAreas: '"label label" ". ." ". ." "battery ." "subGrid subGrid"',
  gridTemplateColumns: '1fr 1fr',
  [theme.breakpoints.down('sm')]: {
    gridTemplateAreas: '"label label" ". ." ". ." "battery ." "subGrid subGrid"'
  }
}));

export const LabelField = styled(InputField)({
  gridArea: 'label'
});

export const BatteryField = styled(InputField)({
  gridArea: 'battery'
});

export const SubGrid = styled('div')(({ theme }) => ({
  display: 'grid',
  gridGap: 16,
  gridTemplateColumns: 'subgrid',
  gridArea: 'subGrid',
  gridTemplateAreas: '"startDelayField minAlertPeriodField"',
  [theme.breakpoints.down('sm')]: {
    gridTemplateAreas: '"startDelayField startDelayField" "minAlertPeriodField minAlertPeriodField"'
  }
}));

// TimeFields styled components for startDelay
export const StartDelayContainer = styled('div')({
  gridArea: 'startDelayField'
});

// TimeFields styled components for minAlertPeriod
export const MinAlertPeriodContainer = styled('div')({
  gridArea: 'minAlertPeriodField'
});

// Shared TimeFields styled components
export const AlertTimeDeviationCnt = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  columnGap: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    '&>*:nth-of-type(3)': {
      '& label': {
        '&.MuiFormLabel-filled': {
          transform: 'translate(17px, 49px) scale(0.75) !important'
        },
        '&.Mui-focused': {
          transform: 'translate(17px, 49px) scale(0.75) !important'
        }
      }
    },
    '& label': {
      paddingLeft: '20px !important',
      '&.MuiFormLabel-filled': {
        transform: 'translate(20px, 49px) scale(0.75) !important'
      },
      '&.Mui-focused': {
        transform: 'translate(20px, 49px) scale(0.75) !important'
      }
    }
  },
  '&>*:nth-of-type(3)': {
    '& label': {
      '&.MuiFormLabel-filled': {
        transform: 'translate(28px, 49px) scale(0.75)'
      },
      '&.Mui-focused': {
        transform: 'translate(28px, 49px) scale(0.75)'
      }
    }
  },
  '& fieldset': {
    top: 0,
    bottom: -5,
    transform: 'rotate(180deg)'
  },
  '& legend': {
    textAlign: 'center'
  },
  '& label': {
    paddingLeft: 15,
    textAlign: 'center',
    '&.MuiInputLabel-shrink': {
      transformOrigin: 'top center'
    },
    '&.MuiFormLabel-filled': {
      padding: 0,
      transform: 'translate(32px, 49px) scale(0.75)'
    },
    '&.Mui-focused': {
      padding: 0,
      transform: 'translate(32px, 49px) scale(0.75)'
    }
  },
  '& input': {
    textAlign: 'center',
    '&::placeholder': {
      textAlign: 'center'
    },
    '&::-webkit-input-placeholder': {
      textAlign: 'center'
    }
  }
}));

export const AlertDeviationFieldTitle = styled('span', {
  shouldForwardProp: prop => !['hasError', 'hasHint'].includes(prop)
})(({ hasError, hasHint }) => ({
  position: 'absolute',
  top: -10,
  left: 8,
  padding: 2,
  backgroundColor: '#fff',
  zIndex: 1,
  color: hasError ? '#FF4635' : '#0000008a',
  fontSize: '0.75rem',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  ...(hasHint && {
    display: 'flex',
    alignItems: 'center'
  })
}));

export const AlertTextError = styled('span')(({ theme }) => ({
  bottom: -24,
  left: 12,
  margin: 0,
  color: '#FF4635',
  fontSize: '0.75rem',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  [theme.breakpoints.down('sm')]: {
    left: 12,
    bottom: -8,
    margin: 0
  }
}));
